import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import H3 from 'components/Primatives/H3';

const InputWrapper = styled.input`
    /* width: 0.1px;
    height: 0.1px; */
    opacity: 0;
    overflow: hidden;
    position: relative;
    z-index: -1;
`
const ContainerWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`
const FieldWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
`
const ImageWrapper = styled.div`
    display: flex;
    background-color: gray;
    border-radius: 20%;
    width: 200px;
    height: 200px;
    opacity: ${props => props.src ? 1 : 0.1};
    background-repeat: no-repeat;
    background-image: url(${ props => props.src});
    background-position: center;
    background-size: cover;
    &:hover {
        cursor: pointer;
    }
    &:focus {
        outline: 1px dotted #000;
	    outline: -webkit-focus-ring-color auto 5px;
    }
`
const ImagePlusVert = styled.div`
    position: relative;
    left: 80px;
    border-radius: 10%;
    margin: auto auto;
    width: 18px;
    height: 135px;
    background-color: black;
    opacity: ${props => props.src ? 0 : 1};
`
const ImagePlusHorizontal = styled.div`
    position: relative;
    left: -19px;
    border-radius: 10%;
    margin: auto auto;
    width: 135px;
    height: 18px;
    background-color: black;
    opacity: ${props => props.src ? 0 : 1};
`
const TitleWrapper = styled.h4`
    font-weight: bold;
    font: 18px Open Sans, Helvetica, sans-serif;
    letter-spacing: 0.3px;
    color: gray;
`
class FormImageInput extends React.Component {

    shouldComponentUpdate(nextProps, nextState){
        return !(nextProps.value === this.props.value);
    }

    render() {
        const { value, onChange, name, label, required, subTitle, ...styleProps } = this.props;
        const isEmptyObject = value => value.constructor === Object && Object.keys(value).length === 0 ? true : false;
        let url;
        if(value){
            if (typeof value === 'string' || value instanceof String){
                url = value
            } else if (!isEmptyObject(value)) { // Check that it is not an empty object
                url = URL.createObjectURL(value);
            } else {
                url = null;
            }
        }
        return(
            <FieldWrapper
                style={styleProps.containerStyle}
            >
                    {   label &&
                        <TitleWrapper
                            test-label='label'
                            style={styleProps.titleStyle}
                        >
                            {label}
                        </TitleWrapper>
                    }

                    <label htmlFor={name}>
                        <ImageWrapper
                            src={ url }
                            name={ name }
                            test-label='imageWrapper'
                            style={styleProps.imageStyle}
                        >
                            <ImagePlusVert src={ url }/>
                            <ImagePlusHorizontal src={ url }/>

                        </ImageWrapper>
                    </label>
                    { subTitle && !url &&
                        <H3>{subTitle}</H3>
                    }
                    <InputWrapper
                        type='file'
                        name={name}
                        id={name}
                        onChange={onChange}
                        test-label='input'
                        style={styleProps.inputStyle}
                        required={required}
                    />
            </FieldWrapper>
        )
    }
}

FormImageInput.propTypes = {
    /** Label to be displayed as the title */
    label: PropTypes.string,
    /** Name of the field passed in, needed for react state changes */
    name: PropTypes.string.isRequired,
    /** Value of the image file to be uploaded */
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    /** onChange function to update the value */
    onChange: PropTypes.func,
};

FormImageInput.defaultProps = {
    label: 'Placeholder label',
    name: 'placeholder',
    value: null,
    onChange: () => null,
};


export default FormImageInput;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/Forms/Components/FormImageInput.js